import { GA_ID } from '../constants';

export const useShouldInit = () => {
  const shouldGoogleAnalyticsInit = GA_ID;

  return {
    shouldGoogleAnalyticsInit,
  };
};
